var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "btn-link cursor-pointer",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.checkStatus.apply(null, arguments)
        },
      },
    },
    [
      _c("span", { staticClass: "text-truncate" }, [
        _vm._v(
          _vm._s(_vm.category.toUpperCase()) + "# " + _vm._s(_vm.currentSO)
        ),
      ]),
      _c(
        "b-modal",
        {
          ref: "saveConfirm",
          attrs: { title: _vm.label, "hide-footer": true },
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _c("validated-input", {
                attrs: { label: _vm.label },
                model: {
                  value: _vm.currentSO,
                  callback: function ($$v) {
                    _vm.currentSO = $$v
                  },
                  expression: "currentSO",
                },
              }),
              _c(
                "b-form-group",
                { attrs: { "invalid-feedback": "Supplier Order Number" } },
                [
                  _c("label", [_vm._v("Query Type")]),
                  _c("b-form-select", {
                    attrs: {
                      options: [
                        { text: "Purchase order from MPower", value: 1 },
                        { text: "Supplier order number", value: 2 },
                        { text: "poSearch", value: 4 },
                      ],
                    },
                    model: {
                      value: _vm.query_type,
                      callback: function ($$v) {
                        _vm.query_type = $$v
                      },
                      expression: "query_type",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "form-group mt-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary mr-2",
                    attrs: {
                      type: "submit",
                      disabled: _vm.errors.any() || _vm.loading,
                    },
                  },
                  [
                    _vm.loading
                      ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
                      : _vm._e(),
                    _vm._v(
                      " " +
                        _vm._s(_vm.category == "so" ? "Save & " : "") +
                        "Check\n          order status"
                    ),
                    _c("i", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.hover",
                          value: {
                            content: `PromoStandards credentials missing. <a href='https://docs.mpowerpromo.com/space/MP/918028316/PromoStandards' target='_blank'>Request credentials</a>.`,
                            html: true,
                          },
                          expression:
                            "{\n              content: `PromoStandards credentials missing. <a href='https://docs.mpowerpromo.com/space/MP/918028316/PromoStandards' target='_blank'>Request credentials</a>.`,\n              html: true\n            }",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "fas fa-question-circle text-light ml-2",
                    }),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: { click: _vm.cancel },
                  },
                  [_vm._v("Cancel")]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }